import { GridColDef } from "@mui/x-data-grid";
import RoleManagement from "../security/roleManagement";
import JWTTokenPayload from "../interfaces/JWTTokenPayload";
import { decodedJWT, getUserRole } from "../utils/commonUtils";

const token: false | JWTTokenPayload = decodedJWT();
const userRole = getUserRole(token);

const clientAgencyContractColumnDef: GridColDef[] = [
  { field: 'contract_id', headerName: 'Contract ID', width: 200 },
  { field: 'agency_name', headerName: 'Agency Name', width: 200 },
  ...RoleManagement.isSuperAdmin(userRole) ? [
    { field: 'client_name', headerName: 'Client Name', width: 200 },
    { field: 'is_active', headerName: 'Status', width: 100 }
  ] : [],
  { field: 'contract_link', headerName: 'Contract Link', width: 300 },
  { field: 'created_date', headerName: 'Created Date', width: 200},
  { field: 'created_by', headerName: 'Created By', width: 200 },
  { field: 'updated_date', headerName: 'Updated Date', width: 200 },
  { field: 'updated_by', headerName: 'Updated By', width: 200 }
];

export default clientAgencyContractColumnDef;
